import { render, staticRenderFns } from "./SolicitudesHistoricasList.html?vue&type=template&id=5f25b85e&external"
import script from "./SolicitudesHistoricasList.vue?vue&type=script&lang=js"
export * from "./SolicitudesHistoricasList.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesHistoricasList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports